export default {
    name: 'Setts',
    data () {
        return {
            is_logged_in:false,
            user:{},
            logdata:{},
            disable_btn:false,
            process_loading:false,
            current_page:0,
        }
    },

    methods: {
        jumpToView(id){
            document.getElementById(id).scrollIntoView();
        },

        toggleView(view){
            let view_set = document.getElementById(view).style.display;
            if(view_set == "none"){
                document.getElementById(view).style.display = "block";
            }else if(view_set == "block"){
                document.getElementById(view).style.display = "none";
            }
        },

        formatCurrency(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            return currency;
        },

        formatCurrency_2(currency){
            currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
            currency =  currency.replace("₦", "") //if sign showing as in Edge browser
            currency =  currency.replace("NGN", ""); //strip off NGN
            currency =  currency.replace(".00", ""); //strip off NGN
            return currency;
        },

        setProcessLoading(){
            this.disable_btn = true;
            this.process_loading = true;
        },

        stopProcessLoading(){
            this.disable_btn = false;
            this.process_loading = false;
        },
        
        isActive(page){
            if(page == this.current_page){
                return true;
            }
        },
    },
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/mixins/setts.js